(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/christmas2025/christmas.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/christmas2025/christmas.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const christmas2025Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/christmas2025");
const BottomFrame = () => React.createElement("div", {
  className: "christmas-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "christmas-bottom-layers relative col-md-12"
}, React.createElement("img", {
  alt: "jul-ram",
  className: "bottom-frame-christmas",
  src: "".concat(christmas2025Path, "/christmas-bottom-frame.png")
})));
const TopFrame = () => React.createElement("div", {
  className: "christmas-top-frame row"
}, React.createElement("div", {
  className: "christmas-top-frame-container relative col-md-12"
}));
const Christmas = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.christmas2025.Christmas', Christmas);

 })(window);